<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home_page/home_Page' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/region_mn/Region_mn' }"
        >区域管理</el-breadcrumb-item
      >
      <el-breadcrumb-item>区域计划</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 查询任务 -->
    <el-form :inline="true" :model="formInline" size="mini" class="task-search">
      <el-form-item label="任务名">
        <el-input
          v-model="formInline.task_name"
          size="mini"
          placeholder="请输入任务名"
        ></el-input>
      </el-form-item>
      <el-form-item label="车辆编号">
        <el-input
          v-model="formInline.car_id"
          placeholder="请输入车辆编号"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" size="mini" @click="onSubmit">搜索</el-button>
        <el-button
          size="mini"
          type="primary"
          icon="el-icon-plus"
          @click="handleAdd"
          >新增任务</el-button
        >
      </el-form-item>
    </el-form>
    <!--任务信息  -->
    <el-table :data="tableData" border style="width: 100%">
      <el-table-column
        fixed
        prop="id"
        label="ID"
        align="center"
        width="80"
        lable-aligin="center"
      >
      </el-table-column>
      <el-table-column
        fixed
        prop="task_name"
        label="任务名"
        align="center"
        width="230"
        lable-aligin="center"
      >
      </el-table-column>
      <el-table-column
        prop="car_carry"
        label="执行车辆"
        align="center"
        lable-aligin="center"
        width="300"
      >
      </el-table-column>
      <el-table-column
        prop="line_name"
        label="执行线路"
        align="center"
        width="200"
        lable-aligin="center"
      >
      </el-table-column>
      <el-table-column
        prop="time_upend"
        label="开始时间-结束时间"
        align="center"
        lable-aligin="center"
        width="350"
      >
      </el-table-column>
      <el-table-column
        prop="count_line"
        label="执行次数"
        align="center"
        width="100"
        lable-aligin="center"
      >
      </el-table-column>
      <el-table-column
        prop="status"
        label="状态"
        width="120"
        align="center"
        lable-aligin="center"
      >
        <template slot-scope="scope">
          <el-tag type="success"> {{ scope.row.status }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        fixed="right"
        label="操作"
        align="center"
        lable-aligin="center"
        width="250"
      >
        <template slot-scope="scope" >
          <el-button size="mini" @click="submitEditForm(scope.row)"
            >编辑任务</el-button
          >
          <el-button size="mini" type="danger" @click="delregion(scope.row)"
            >中止并删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination
      v-bind:child-msg="pageparm"
      @callFather="callFather"
    ></Pagination>
    <!-- 新增任务弹框 -->
    <el-dialog
      title="新增任务"
      :visible.sync="dialogFormVisible"
      width="35%"
      @click="closeDialog"
      :destroy-on-close="true"
      :close-on-click-modal="false"
    >
      <div style="margin-right: 5%">
        <el-form
          ref="addForm"
          :model="addForm"
          :rules="rules"
          label-width="140px"
        >
          <el-form-item label="任务名" prop="task_name">
            <el-input
              size="mini"
              v-model="addForm.task_name"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item label="执行车辆" prop="car_carry">
            <el-select
              size="mini"
              v-model="addForm.car_carry"
              filterable
              clearable
              placeholder="请选择"
              @click="carClick()"
            >
              <el-option
                v-for="item in carplan"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="执行线路" prop="line_name">
            <el-select
              size="mini"
              v-model="addForm.line_name"
              filterable
              clearable
              @click="lineClick()"
              placeholder="请选择"
            >
              <el-option
                v-for="item in lineplan"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="开始时间-结束时间" prop="time_upend">
            <div class="block">
              <el-date-picker
                v-model="addForm.time_upend"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :default-time="['08:30:00', '17:00:00']"
              >
              </el-date-picker>
            </div>
          </el-form-item>
          <el-form-item label="执行次数" prop="count_line">
            <el-input
              size="mini"
              v-model="addForm.count_line"
              autocomplete="off"
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button
            size="mini"
            type="primary"
            @click="submitFormAdd('addForm')"
            >保存</el-button
          >
          <el-button size="small" @click="closeDialog('addForm')"
            >取 消</el-button
          >
        </div>
      </div>
    </el-dialog>
    <!-- 编辑任务弹框 -->
    <el-dialog
      title="编辑任务"
      :visible.sync="editFormdata"
      width="35%"
      @click="closeDialog"
      :destroy-on-close="true"
      :close-on-click-modal="false"
    >
      <div style="margin-right: 5%">
        <el-form
          ref="editForm"
          :model="editForm"
          :rules="rules"
          label-width="140px"
        >
          <el-form-item label="任务名" prop="task_name">
            <el-input
              size="mini"
              v-model="editForm.task_name"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item label="执行车辆" prop="car_carry">
            <el-select
              size="mini"
              v-model="editForm.car_id"
              filterable
              clearable
              @click="carEditClick"
              placeholder="请选择"
            >
              <el-option
                v-for="item in car_plan"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="执行线路" prop="line_name">
            <el-select
              size="mini"
              v-model="editForm.line_id"
              filterable
              clearable
              @click="lineEditClick"
              placeholder="请选择"
            >
              <el-option
                v-for="item in line_plan"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="开始时间-结束时间" prop="time_upend">
            <div class="block">
              <el-date-picker
                v-model="editForm.time_upend"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="datetimerange"
                clearable
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :default-time="['08:30:00', '17:00:00']"
              >
              </el-date-picker>
            </div>
          </el-form-item>
          <el-form-item label="执行次数" prop="count_line">
            <el-input
              size="mini"
              v-model="editForm.count_line"
              autocomplete="off"
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="mini" type="primary" @click="submitForm('editForm')"
            >保存</el-button
          >
          <el-button size="small" @click="closeDialog('editForm')"
            >取 消</el-button
          >
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Pagination from "../../components/Pagination";
import {
  get_regionPlan_list,
  get_area_cars_on_inserting,
  get_area_lines,
  get_regionPlan_add,
  get_regionPlan_one,
  get_regionPlan_edit,
  get_area_cars_on_updating,
  get_regionPlan_del,
} from "../../api/region/regionPlan";
export default {
  data() {
    return {
      dialogFormVisible: false, //添加任务表单是否显示
      editFormdata: false, //编辑任务表单
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10,
      },
      formInline: {
        task_name: "",
        car_id: "",
        page: 1,
        limit: 10,
      },
      tableData: [],
      //添加表单
      addForm: {
        task_name: "",
        car_carry: "",
        line_name: "",
        time_upend: [],
        count_line: "",
        status: "",
      },
      //执行车辆选择添加编辑
      carplan: [],
      //执行线路选择添加编辑
      lineplan: [],
      //执行车辆选择修改编辑
      car_plan: [],
      //执行线路选择修改编辑
      line_plan: [],
      //编辑表单
      editForm: {
        id: "",
        task_name: "",
        car_id: "",
        line_id: "",
        car_carry: "",
        line_name: "",
        time_upend: [],
        count_line: "",
        status: "",
      },
      //添加校验规则
      rules: {
        task_name: [
          { required: true, message: "请输入任务名", trigger: "blur" },
          {
            pattern: /^[0-9\u0391-\uFFE5]+$/,
            message: "请输入准确的任务名，如：测试",
            trigger: "blur",
          },
        ],
        car_carry: [
          { required: true, message: "请选择执行车辆", trigger: "change" },
        ],
        line_name: [
          { required: true, message: "请选择线路名称", trigger: "change" },
        ],
        time_upend: [
          { required: true, message: "请选择执行时间", trigger: "blur" },
        ],
        count_line: [
          { required: true, message: "请输入执行次数", trigger: "blur" },
          {
            pattern: /^\d+$|^\d+[.]?\d+$/,
            message: "请输入数字，如：33",
            trigger: "blur",
          },
        ],
        // status: [{ required: true, message: "请输入状态", trigger: "blur" }],
      },
    };
  },
  components: {
    Pagination,
  },
  created() {
    this.getdata();
  },
  methods: {
    //查询区域计划列表
    getdata() {
      get_regionPlan_list(this.formInline).then((res) => {
        if (res["code"] === 0) {
          this.tableData = res.data;
          this.pageparm.currentPage = this.formInline.page;
          this.pageparm.pageSize = this.formInline.limit;
          this.pageparm.total = res["count"];
        } else {
          this.$message.error(res["message"]);
        }
      });
    },
    //添加绑定车辆下拉列表
    carClick() {
      get_area_cars_on_inserting().then((res) => {
        if (res["code"] === 0) {
          this.carplan = res.data;
        } else {
          this.$message.error(res["message"]);
        }
      });
    },
    //添加绑定线路下拉列表
    lineClick() {
      get_area_lines().then((res) => {
        if (res["code"] === 0) {
          this.lineplan = res.data;
        } else {
          this.$message.error(res["message"]);
        }
      });
    },
    //修改绑定车辆下拉列表
    carEditClick() {
      return get_area_cars_on_updating(this.editForm.car_id).then((res) => {
        if (res["code"] === 0) {
          this.car_plan = res.data;
          for (var i = 0; i < this.car_plan.length; i++) {
            if (this.editForm.car_id === this.car_plan[i].value) {
              this.editForm.car_carry = this.car_plan[i].label;
            }
          }
        } else {
          this.$message.error(res["message"]);
        }
      });
    },
    //修改绑定线路下拉列表
    lineEditClick() {
      get_area_lines().then((res) => {
        if (res["code"] === 0) {
          this.line_plan = res.data;
          for (var i = 0; i < this.line_plan.length; i++) {
            if (this.editForm.line_id === this.line_plan[i].value) {
              this.editForm.line_name = this.line_plan[i].label;
            }
          }
        } else {
          this.$message.error(res["message"]);
        }
      });
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage;
      this.formInline.limit = parm.pageSize;
      this.getdata();
    },
    //查询搜索
    onSubmit() {
      this.formInline.page = 1;
      this.getdata();
    },
    //添加界面
    handleAdd() {
      this.dialogFormVisible = true;
      this.carClick();
      this.lineClick();
      this.addForm = {};
    },
    //添加保存方法
    submitFormAdd(addData) {
      this.$refs[addData].validate((valid) => {
        if (valid) {
          get_regionPlan_add(this.addForm).then((res) => {
            if (res["code"] === 0) {
              this.addForm = {};
              this.getdata();
              this.carClick();
              this.lineClick();
              this.$message.success(res["message"]);
              this.dialogFormVisible = false;
            } else {
              this.$message.error(res["message"]);
              this.loading = false;
            }
          });
        } else {
          return false;
        }
      });
    },
    //获取单条计划
    async submitEditForm(row) {
      await get_regionPlan_one(row.id).then((res) => {
        if (res["code"] === 0) {
          this.editForm = res.data;
          this.lineEditClick();
          this.$set(this.editForm, "time_upend", [
            res.data.start_time,
            res.data.end_time,
          ]);
        } else {
          this.$message.error(res["message"]);
        }
      });
      await this.carEditClick();
      this.editFormdata = true;
    },
    //------------------------------------------------------------------------------------//

    //修改保存方法
    submitForm(form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          get_regionPlan_edit(this.editForm).then((res) => {
            this.editFormdata = false;
            if (res["code"] === 0) {
              this.getdata();
              this.editForm = {};
              this.$message.success(res["message"]);
            } else {
              this.$message.error(res["message"]);
            }
          });
        } else {
          return false;
        }
      });
    },
    //删除按钮
    delregion(row) {
      this.$confirm("确定要删除吗?", "信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        closeOnClickModal:false,
        type: "warning",
      })
        .then(() => {
          get_regionPlan_del(row.id).then((res) => {
            if (res["code"] === 0) {
              this.$message.success(res["message"]);
              if (this.tableData.length === 1) {
                if (this.formInline.page === 1) {
                  this.getdata();
                } else {
                  this.formInline.page = this.formInline.page - 1;
                  this.getdata();
                }
              } else {
                this.getdata();
              }
            } else {
              this.$message.error(res["message"]);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 关闭编辑、增加弹出框
    closeDialog(formName) {
      this.editFormdata = false;
      this.$refs[formName].resetFields();
      this.dialogFormVisible = false;
    },
  },
};
</script>

<style>
.task-search {
  margin-top: 30px;
  width: 100%;
  height: 80px;
}
</style>


// WEBPACK FOOTER //
// src/views/region_mn/Regionplan.vue